import { HttpContextToken } from '@angular/common/http';
import { CredentialContext } from './credential-transition';

// Captured once at dispatch and retained through authentication replay.
export const CREDENTIAL_REQUEST = new HttpContextToken<CredentialContext | null>(() => null);
